import Tooltip from '../Tooltip/Tooltip'
import classes from './TestConfigTagBadge.module.scss'

export interface Props {
  label: string
}

const TestConfigTagBadge = ({
  label
}: Props) =>
  <Tooltip label={label}>
    <span
      aria-label='TestConfigTagBadge'
      className={classes.TestConfigTagBadge}
    >
      {label}
    </span>
  </Tooltip>

export default TestConfigTagBadge
